export function formatPixeFromCents(cents?: number | null): string {
  if (cents == null || !Number.isFinite(cents)) return ''
  const value = Number(cents) / 100
  if (Number.isInteger(value)) return String(value)
  return value.toFixed(2)
}

const PIXE_ATOMIC_SCALE = 1000000000000n

function formatBigIntWithCommas(value: bigint): string {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function formatPixeAtomic(value?: string | number | bigint | null): string {
  if (value == null) return '0'
  let atomic: bigint
  try {
    atomic = typeof value === 'bigint' ? value : BigInt(String(value))
  } catch {
    return '0'
  }
  const neg = atomic < 0n
  const abs = neg ? -atomic : atomic
  const whole = abs / PIXE_ATOMIC_SCALE
  const frac = abs % PIXE_ATOMIC_SCALE
  const wholeText = formatBigIntWithCommas(whole)
  if (frac === 0n) return neg ? `-${wholeText}` : wholeText
  const fracText = frac.toString().padStart(12, '0').replace(/0+$/, '')
  const text = `${wholeText}.${fracText}`
  return neg ? `-${text}` : text
}
